import React from 'react';
import { Table } from 'semantic-ui-react';
import { map, addIndex } from 'ramda';
import { generate } from 'shortid';


//const colWidths = [2, 1, 2, 3, 3, 5];

const TableHeader = (props) => {
  const { cols } = props,
        ixMap = addIndex(map);

  return (
    <Table.Header>
      <Table.Row>
        {
          ixMap(({ title }, ix) =>
                //<Table.HeaderCell key={'cell_'+ ix} width={colWidths[ix]}>
                <Table.HeaderCell key={generate()} collapsing>
                  {title} 
                </Table.HeaderCell>,
                cols)
        }
      </Table.Row>
    </Table.Header>
  );
};

export default TableHeader;



// WEBPACK FOOTER //
// ./src/private/common/components/AwsJsonTable/Header.js